
import React, { useState , useEffect } from 'react';
import "./App.css";
import BPMCounter   from "./components/Utilities/BPMCounter";
import GuitarExParent       from './components/Exercises/GuitarExParent'
import Home         from "./components/Home/Home";
import MyNav        from "./components/MyNav/MyNav";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import  TheoryGuitarTriad from './components/Theory/Guitar/TriadComponent';
import HSR from "./components/Advertising/HSR";
import Privacy from "./components/Privacy/Privacy";
import LinkService from "./services/LinkService";
import PianoMajorMinorScales from "./components/Theory/Piano/PianoMajorMinorScale";
import PianoTriadChords from "./components/Theory/Piano/PianoTriadChords";
import PianoTriadChordReference from "./components/Theory/Piano/PianoTriadChordReference";
import Contact from './components/Contact/Contact';

function App() {
    const [isFetching] = useState(false);
    let linkService = new LinkService()

    return (
        <div className="d-flex flex-column min-vh-100 app">
            <div className="container flex-grow-1">
      <MyNav/>
      <BrowserRouter>
        <Routes>
          <Route path="/">
              <Route path='/' element={<Home/>} />
              <Route path='/utilities/bpm_counter' element={<BPMCounter/>} />
                <Route path='/contact' element={<Contact/>} />
              <Route path={linkService.THEORY_PIANO_MAJ_MIN}  element={<PianoMajorMinorScales />}/>
              <Route path={linkService.THEORY_PIANO_TRIADS}  element={<PianoTriadChords />}/>
              <Route path={linkService.PIANO_TRIAD_REFERENCE} element={<PianoTriadChordReference/>}/>
              <Route path='/exercises/guitar/:id'  element={<GuitarExParent />}/>
              <Route path='/theory/guitar/triads/:id' element={<TheoryGuitarTriad/>} />
              <Route path='/privacy' element={<Privacy/>} />
          </Route>
        </Routes>
      </BrowserRouter>
        {
          isFetching ? <div className="container flex-grow-1">Loading...</div> :(

              <div className="container">
                  <div className="row centercell">
                      <div className="col-sm-1"></div>
                      <div className="col-sm-10" id="bottomrow">

                          <HSR />
                          <br /><br />

                      </div>
                      <div className="col-sm-1"></div>
                  </div>
              </div>)
        }
            </div>
        </div>
    );
}

export default App;
